export default "__VITE_ASSET__B6c$d8m7__"